var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32234 20.6125C10.161 19.8383 12.2417 19.3544 14.5159 19.306V15.4351H7.7417C7.79009 17.2738 7.98363 19.0157 8.32234 20.6125Z",
    fill: "#4EA27D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7417 14.4679H14.5159V10.597C12.2417 10.5486 10.161 10.1131 8.32234 9.29053C7.98363 10.8873 7.79009 12.6292 7.7417 14.4679Z",
    fill: "#4EA27D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5161 0C11.7096 1.45161 9.62897 4.35483 8.56445 8.32256C10.3064 9.14514 12.3386 9.58062 14.5161 9.62901V0Z",
    fill: "#4EA27D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5488 8.85482C22.9359 10.5967 23.1779 12.4838 23.2262 14.4677H30.0004C29.9037 11.0806 28.6456 7.98385 26.6617 5.51611C25.5004 6.91934 24.1456 8.03224 22.5488 8.85482Z",
    fill: "#4EA27D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2262 15.4351C23.1779 17.4673 22.9843 19.3544 22.5488 21.0479C24.1456 21.8705 25.5004 22.9834 26.6617 24.3867C28.6456 21.9189 29.9037 18.8221 30.0004 15.4351H23.2262Z",
    fill: "#4EA27D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4839 0V9.62901C17.6613 9.58062 19.6452 9.14514 21.4355 8.32256C20.371 4.40322 18.2903 1.45161 15.4839 0Z",
    fill: "#4EA27D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5161 29.9029V20.2739C12.3386 20.3223 10.3548 20.7578 8.56445 21.5804C9.62897 25.4997 11.7096 28.4513 14.5161 29.9029Z",
    fill: "#4EA27D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3064 7.88694C23.758 7.11275 24.9677 6.04823 25.9838 4.79017C23.8064 2.37082 20.8548 0.725663 17.5161 0.14502C19.7419 1.88695 21.3871 4.54824 22.3064 7.88694Z",
    fill: "#4EA27D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4516 21.0479C7.0645 19.306 6.82257 17.4189 6.77418 15.4351H0C0.096774 18.8221 1.35484 21.9189 3.3387 24.3867C4.49999 22.9834 5.85483 21.8705 7.4516 21.0479Z",
    fill: "#4EA27D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3387 5.51611C1.35484 7.98385 0.096774 11.0806 0 14.4677H6.77418C6.82257 12.4355 7.01611 10.5484 7.4516 8.85482C5.85483 8.03224 4.49999 6.91934 3.3387 5.51611Z",
    fill: "#4EA27D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69352 22.0161C6.24191 22.7903 5.03224 23.8548 4.01611 25.1129C6.19353 27.4838 9.14513 29.129 12.4838 29.7096C10.258 28.0161 8.61288 25.3548 7.69352 22.0161Z",
    fill: "#4EA27D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3064 22.0161C21.3871 25.3548 19.7419 28.0161 17.5161 29.7096C20.8548 29.129 23.8064 27.4838 25.9838 25.1129C24.9677 23.8548 23.758 22.7903 22.3064 22.0161Z",
    fill: "#4EA27D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69352 7.88689C8.61288 4.54819 10.258 1.8869 12.4838 0.193359C9.14513 0.725616 6.19353 2.37077 4.01611 4.79012C5.03224 6.04819 6.24191 7.1127 7.69352 7.88689Z",
    fill: "#4EA27D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2581 15.4351H15.4839V19.306C17.7581 19.3544 19.8387 19.7899 21.6774 20.6125C22.0161 19.0157 22.2097 17.2738 22.2581 15.4351Z",
    fill: "#4EA27D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6774 9.29053C19.8387 10.0647 17.7581 10.5486 15.4839 10.597V14.4679H22.2581C22.2097 12.6292 22.0161 10.8873 21.6774 9.29053Z",
    fill: "#4EA27D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4355 21.5804C19.6936 20.7578 17.6613 20.3223 15.4839 20.2739V29.8545C18.2903 28.4513 20.371 25.4997 21.4355 21.5804Z",
    fill: "#4EA27D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.6d23e7ed.svg";
export { ForwardRef as ReactComponent };